const REVIEW_STAGES = new Set(['NEW']);
const CONTACT_STAGES = new Set(['CONTACTED', 'UNRESPONSIVE', 'NO_SHOW']);
const INTERVIEW_STAGES = new Set(['INTERVIEW_SCHEDULED', 'INTERVIEWED']);
const BLOCKED_STAGES = new Set(['UNRESPONSIVE', 'NO_SHOW']);

const STAGE_BADGE_VARIANTS = {
  NEW: 'info',
  CONTACTED: 'cyan',
  SCREENING: 'purple',
  INTERVIEW_SCHEDULED: 'warning',
  INTERVIEWED: 'warning',
  HIRED: 'success',
  ONBOARDING: 'success',
  REJECTED: 'neutral',
  NO_SHOW: 'danger',
  UNRESPONSIVE: 'danger',
};

const NEXT_ACTIONS = {
  NEW: 'Review',
  CONTACTED: 'Follow up',
  SCREENING: 'Screen',
  INTERVIEW_SCHEDULED: 'Prepare',
  INTERVIEWED: 'Decision',
  HIRED: 'Onboard',
  ONBOARDING: 'Onboard',
  REJECTED: 'Archive',
  NO_SHOW: 'Reschedule',
  UNRESPONSIVE: 'Reconnect',
};

function hasMissingContact(applicant = {}) {
  return !String(applicant.phone || '').trim() && !String(applicant.email || '').trim();
}

function hasIncompleteContact(applicant = {}) {
  return !String(applicant.phone || '').trim();
}

export function getApplicantWarningLabel(applicant = {}) {
  if (hasMissingContact(applicant)) return 'Missing contact';
  if (BLOCKED_STAGES.has(applicant.stage)) return 'Blocked';
  return '';
}

export function getApplicantNextAction(applicant = {}) {
  if (hasMissingContact(applicant)) return 'Complete info';
  return NEXT_ACTIONS[applicant.stage] || 'Review';
}

export function getApplicantStageBadgeVariant(stage) {
  return STAGE_BADGE_VARIANTS[stage] || 'neutral';
}

export function getApplicantDisplayName(applicant = {}) {
  const parts = [applicant.first_name, applicant.last_name]
    .map(part => String(part || '').trim())
    .filter(Boolean);
  if (parts.length > 0) return parts.join(' ');
  if (applicant.external_id) return `Applicant ${applicant.external_id}`;
  if (applicant.id) return `Applicant ${applicant.id}`;
  return 'Applicant';
}

export function getApplicantInitials(applicant = {}) {
  const displayName = getApplicantDisplayName(applicant);
  const initials = displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');
  return initials || 'A';
}

export function buildApplicantQueueCards(applicants = []) {
  const values = Array.isArray(applicants) ? applicants : [];
  return [
    {
      label: 'Needs review',
      count: values.filter(applicant => REVIEW_STAGES.has(applicant.stage)).length,
      tone: 'info',
      stageFilter: 'NEW',
    },
    {
      label: 'Needs contact',
      count: values.filter(applicant => CONTACT_STAGES.has(applicant.stage)).length,
      tone: 'warning',
      stageFilter: 'CONTACTED',
    },
    {
      label: 'Interview / next step',
      count: values.filter(applicant => INTERVIEW_STAGES.has(applicant.stage)).length,
      tone: 'purple',
      stageFilter: 'INTERVIEW_SCHEDULED',
    },
    {
      label: 'Blocked / missing info',
      count: values.filter(applicant => BLOCKED_STAGES.has(applicant.stage) || hasIncompleteContact(applicant)).length,
      tone: 'danger',
      stageFilter: 'UNRESPONSIVE',
    },
  ];
}
